import React from "react";
import {StyledPricingList} from "./PricingList.style";
import Logo from "../../../assets/plates-logo.png";
import {RiArrowLeftSLine} from "react-icons/ri";
import {MdLogout} from "react-icons/md";
import Button from "components/molecules/Button";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useAuthContext} from "Context/authContext";
import PricingSection from "./PricingSection";

const PricingList = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const {isLoggedIn, onLogout} = useAuthContext();
    const businessId = searchParams.get('businessId');
    const businessName = searchParams.get('businessName');
    
    const handleLogout = async () => {
        await onLogout();
        navigate('/');
    };
    return (
        <StyledPricingList>
            <div className="top-navigation">
                {!isLoggedIn && (
                    <Button width="87px" className="btn" variant="white" gap="1px !important" onClick={() => navigate(-1)}>
                        <RiArrowLeftSLine />
                        Back
                    </Button>
                )}
                {isLoggedIn && (
                    <Button width="100px" className="btn logout-btn" variant="danger" gap="1px !important" onClick={handleLogout}>
                        <MdLogout />
                        Logout
                    </Button>
                )}
            </div>
            <div className="logo-wrap">
                <img src={Logo} alt="Logo" className="logo" />
            </div>
            <h2 className="title">
                {businessName ? `Choose a plan for ${decodeURIComponent(businessName)}` : "Flexible Pricing for Every Business"}
            </h2>
            <PricingSection businessIdFromUrl={businessId} />
        </StyledPricingList>
    );
};

export default PricingList;
